import Vue from 'vue'
import Component from 'vue-class-component'
import {Getter} from 'vuex-class'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import $ from 'jquery'

@Component({})
export default class BaseError extends Vue {

    @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string
    @Getter('customerDetails', StoreNamespace.AUTHENTICATION) customerDetails!: string

    created() {
        $('body').addClass(this.mngCompanyName)
    }

    get hasMngCompanyName(): boolean {
        return !!this.mngCompanyName
    }

    goToLogin(): void {
        this.$router.push('/login/' + this.mngCompanyName)
    }

    goToLobby(): void {
        this.$router.push({name: 'lobby'})
    }
}